import GraphQL from './GraphQL'

class CartClass {
    constructor() {
        this.url = '/shop/cart/'
    }

    setCartQuantity() {
        this.getCount((err, res) => {
            if (res >= 0) {
                const headerCartCountNode = document.getElementById('header-cart-count')

                if (headerCartCountNode) headerCartCountNode.innerHTML = res
            }
        })
    }

    getCount(cb) {
        GraphQL.query('cart_get_count', {
            
        }, {}, cb)
    }

    add(PRODUCT_ID, QUANTITY=1, cb) {
        GraphQL.query('cart_add', {
            'PRODUCT_ID : Int!' : PRODUCT_ID,
            'QUANTITY : Int!' : QUANTITY
        }, {}, (err, res) => {
            if (err) {
                if (Array.isArray(err) && err.filter((_err) => _err.code == 20403).length > 0) {
                    document.location = '/shop/cart/'
                }
            } else {
                this.setCartQuantity()
            }

            if (cb) cb(err, res)
        })
    }

    remove(ID, cb) {
        GraphQL.query('cart_remove', {
            'ID : Int!' : ID,
        }, {}, (err, res) => {
            this.setCartQuantity()

            if (cb) cb(err, res)
        })
    }
    
    change(ID, QUANTITY=1, cb) {
        GraphQL.query('cart_change', {
            'ID : Int!' : ID,
            'QUANTITY : Int!' : QUANTITY
        }, {}, (err, res) => {
            this.setCartQuantity()

            if (cb) cb(err, res)
        })
    }

    setCoupon(CODE, cb) {
        GraphQL.query('cart_set_coupon', {
            'CODE : String!' : CODE,
        }, {}, cb)
    }

    getCart(cb, fields={ count : null, count_format : null, summary : null, summary_format : null, summary_base : null, summary_base_format : null, discount_summary : null, discount_summary_format : null, coupons : null, items : { ID : null, PRODUCT_ID : null, DETAIL_PAGE_URL : null, NAME : null, WEIGHT : null, WEIGHT_FORMAT : null, DISCOUNT_SUMMARY_PRICE : null, DISCOUNT_SUMMARY_PRICE_FORMAT : null, PRICE : null, PRICE_FORMAT : null, SUMMARY : null, SUMMARY_FORMAT : null, BASE_PRICE : null, BASE_PRICE_FORMAT : null, BASE_PRICE_SUMMARY : null, BASE_PRICE_SUMMARY_FORMAT : null, DISCOUNT_PERCENT : null, DISCOUNT_PRICE : null, DISCOUNT_PRICE_FORMAT : null, QUANTITY : null, OLD_QUANTITY : null, AMOUNT : null, CAN_BUY : null, IS_DELAY : null, CURRENCY : null, PREVIEW_PICTURE : null } }, CHECK_AMOUNT = false, PAYMENT_ID = null) {
        GraphQL.query('cart_get', {
            'CHECK_AMOUNT : Boolean!' : CHECK_AMOUNT,
            'PAYMENT_ID : Int' : PAYMENT_ID
        }, fields, cb)
    }

    getInfo(cb, fields={ count : null, count_format : null, summary : null, summary_format : null, discount_summary : null, discount_summary_format : null }) {
        GraphQL.query('cart_get_info', {
            
        }, fields, cb)
    }
    
    getItems(cb, fields={ ID : null, PRODUCT_ID : null, DETAIL_PAGE_URL : null, NAME : null, WEIGHT : null, WEIGHT_FORMAT : null, PRICE : null, PRICE_FORMAT : null, SUMMARY : null, SUMMARY_FORMAT : null, BASE_PRICE : null, BASE_PRICE_FORMAT : null, DISCOUNT_PERCENT : null, DISCOUNT_PRICE : null, DISCOUNT_PRICE_FORMAT : null, DISCOUNT_SUMMARY_PRICE : null, DISCOUNT_SUMMARY_PRICE_FORMAT : null,  QUANTITY : null, AMOUNT : null, CAN_BUY : null, IS_DELAY : null, CURRENCY : null, PREVIEW_PICTURE : null }) {
        GraphQL.query('cart_get_items', {
            
        }, fields, cb)
    }

    updateAmounts(ids=[], cb) {
        GraphQL.query('cart_update_amount', {
            'IDS : String!' : JSON.stringify(ids),
        }, {}, cb)
    }

    getGifts(cb, fields={ ID : null, NAME : null, DETAIL_PAGE_URL : null, PREVIEW_PICTURE : null }) {
        GraphQL.query('cart_get_gifts', {
            
        }, fields, cb)
    }

    getCardNumberByPhone(PHONE, cb) {
        GraphQL.query('cart_get_card_number', {
            'PHONE : String!' : PHONE,
        }, {}, cb)
    }    
}

const Cart = new CartClass()

export default Cart